import React, { useState } from 'react'
import { MDBIcon } from 'mdb-react-ui-kit'
import { getFaqs } from './../../content'

import './FaqAccordion.component.scss'

const FaqAccordion = ({ subsiteData }) => {
  const faqs = getFaqs(subsiteData)
  const [openIndex, setOpenIndex] = useState(-1)

  const toggle = i => setOpenIndex(prev => (prev === i ? -1 : i))

  return (
    <section id='FaqAccordion' className='subsite-section'>
      <div className='subsite-shell'>
        <h2 className='subsite-section-title'>Frequently Asked Questions</h2>
        <ul className='faq-list'>
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i
            return (
              <li key={`faq-${i}`} className={`faq-item${isOpen ? ' is-open' : ''}`}>
                <button type='button' className='faq-question' aria-expanded={isOpen} onClick={() => toggle(i)}>
                  <h3>{faq.question}</h3>
                  <MDBIcon icon='chevron-down' className='faq-chevron' />
                </button>
                <div className='faq-answer'>
                  <div className='faq-answer-inner'>
                    <p>{faq.answer}</p>
                  </div>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default FaqAccordion
